import { FileWithPath } from '@mantine/dropzone';
import { z } from 'zod';

export const CREATE_PUBLISHER_SCHEMA = z.object({
  title: z
    .string()
    .min(3, 'Минимальная длина 3 символа')
    .max(100, 'Максимальная длина 100 символов'),
  url: z.string().url({ message: 'Введите корректную ссылку' }),
  description: z
    .string()
    .max(1000, 'Максимальная длина 1000 символов')
    .optional(),
  previewFile: z.optional(z.custom<FileWithPath>()),
});

export const KITABA_CREATE_PUBLISHER_SCHEMA = CREATE_PUBLISHER_SCHEMA.extend({
  url: z.union([
    z.literal(''),
    z.string().url({ message: 'Введите корректную ссылку' }),
  ]),
});
